export const configuration = {
  apiUrl: process.env.REACT_APP_API_URL,
  apiAuthUrl: process.env.REACT_APP_API_URL,
  apiAdminUrl: process.env.REACT_APP_API_URL
}
